import React from 'react';
import { SurveyQuestionsModal } from '@/components/modals/survey/SurveyQuestionsModal';
import {
	CaseQuestionI,
	FileType,
	FollowUpQuestion,
	FollowUpQuestionOption,
} from '@/interfaces';

interface Props {
	data: FileType | undefined;
	isOpen: boolean;
	setIsModalOpen: (value: boolean) => void;
}

export const ModalFollowUpAnswers: React.FC<Props> = ({
	data,
	isOpen,
	setIsModalOpen,
}) => {
	const options: CaseQuestionI[] = React.useMemo(() => {
		if (!data) return [];
		const questions = data.questions as FollowUpQuestion[];

		const getAnswer = (options: FollowUpQuestionOption[]) => {
			return options.find((op) => op.selected)?.text.toUpperCase();
		};

		return questions?.map((q) => ({
			id: q.id,
			question: q.text,
			question_type: q.type,
			multiple_choise_questions: [],
			ask_explanation: q.explanation,
			answer:
				q.type === 'YES_NO' && q.options
					? getAnswer(q.options)
					: q.answer ?? undefined,
		}));
	}, [data]);

	return (
		<SurveyQuestionsModal
			heading={data?.heading}
			description={data?.description}
			title={data?.file_name ?? 'Answer Follow-Up'}
			questions={options}
			isOpen={isOpen}
			onClose={() => setIsModalOpen(false)}
			isViewOnly={true}
		/>
	);
};
